import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';

import { CalendarViewComponent } from '@module-instance/calendar/calendar-view/calendar-view.component';
import { DataCardsViewComponent } from '@module-instance/data-card/data-cards-view/data-cards-view.component';
import { AccessLogTabComponent } from '@module-instance/dynamic-module/document-details/document-details-tabs/access-log-tab/access-log-tab.component';
import { DocumentDetailsTabsComponent } from '@module-instance/dynamic-module/document-details/document-details-tabs/document-details-tabs.component';
import { PdfMarkupTabComponent } from '@module-instance/dynamic-module/document-details/document-details-tabs/pdf-markup-tab/pdf-markup-tab.component';
import { RelationsTabComponent } from '@module-instance/dynamic-module/document-details/document-details-tabs/relations-tab/relations-tab.component';
import { GanttViewComponent } from '@module-instance/gantt/gantt-view.component';
import { ProgressPaymentComponent as ProgressPaymentAngularJsComponent } from '@module-instance/progress-payment/pp-angularjs.component';
import { CipoAddressAngularJsComponent } from '@shared/components/fields/cipo-address/cipo-address.angularjs.component';

export const Ng1ModuleInstance = angular
  .module('ng1module.module-instance', [])
  .directive('appDataCardsView', downgradeComponent({ component: DataCardsViewComponent }) as angular.IDirectiveFactory)
  .directive('appCalendarView', downgradeComponent({ component: CalendarViewComponent }) as angular.IDirectiveFactory)
  .directive('appGanttView', downgradeComponent({ component: GanttViewComponent }) as angular.IDirectiveFactory)
  .directive('cipoRelationsTab', downgradeComponent({ component: RelationsTabComponent }) as angular.IDirectiveFactory)
  .directive('cipoAccessLogTab', downgradeComponent({ component: AccessLogTabComponent }) as angular.IDirectiveFactory)
  .directive('cipoPdfMarkupTab', downgradeComponent({ component: PdfMarkupTabComponent }) as angular.IDirectiveFactory)
  .directive(
    'cipoDocumentDetailsTabs',
    downgradeComponent({ component: DocumentDetailsTabsComponent }) as angular.IDirectiveFactory,
  )
  .directive(
    'cipoProgressPayment',
    downgradeComponent({ component: ProgressPaymentAngularJsComponent }) as angular.IDirectiveFactory,
  )
  .directive(
    'cipoAddressAngularjs',
    downgradeComponent({ component: CipoAddressAngularJsComponent }) as angular.IDirectiveFactory,
  ).name;
